import * as React from "react";
import { forwardRef } from "react";
const SvgUpArrowGreen = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", focusable: "false", xmlns: "http://www.w3.org/2000/svg", fill: "#36B37E", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M11.293 5.293l-5.5 5.499a1.002 1.002 0 0 0 0 1.415.999.999 0 0 0 1.414 0L11 8.414V18a1 1 0 0 0 2 0V8.414l3.793 3.793a1 1 0 1 0 1.414-1.415l-5.5-5.499A.993.993 0 0 0 12 5a.993.993 0 0 0-.707.293z", fillRule: "evenodd" }));
const ForwardRef = forwardRef(SvgUpArrowGreen);
export default ForwardRef;
